import React, { type FunctionComponent } from 'react'
import { RetailerLocaleSelect } from 'gin-and-tonic/containers/locale-select/LocaleSelect'
import { useQueryParam } from 'use-query-params'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'
import { stringQueryParamEncoder } from 'utils/query-params/string.utils'

/**
 * TODO: REMOVE ME
 *
 * the sole purpose of this component is to provide locale functionality to older catalog/aisles pages
 * since the data is provided via a HOC, it makes it harder to properly pass around
 * this sidesteps the issue by using query params directly.
 */
export const LegacyRetailerLocaleSelect: FunctionComponent = () => {
  const { warehouse } = useWarehouseContext()
  const [locale, setLocale] = useQueryParam('locale', stringQueryParamEncoder)

  return (
    <RetailerLocaleSelect
      value={locale || warehouse.defaultLocale.localeCode}
      onChange={evt => setLocale(evt.localeCode)}
    />
  )
}
